<template>
  <div id="topo">
    <nav id="nav" class="white">
      <div class="">
        <div class="brand">
          <a href="#topo" class="scrollSuave brand-logo ">
            <img 
              src=".././assets/img/juscilan.jpeg" 
              class="circle bordabranca img-width" 
              alt="Juscilan Moreto" 
              title="Juscilan Moreto"
            >
          </a>
        </div>
        <a href="#" data-activates="mobile-demo" class="button-collapse"><i class="material-icons hamburguer"  style="font-size:48px">menu</i></a>
        <ul class=" hide-on-med-and-down nav-regular right">
            <li>
              <a href="#topo" class="scrollSuave" id="start">Home</a>
            </li>
            <li>              
              <a class="pdf-resume" href="#" @click="AbreModal()">
                <img src=".././assets/img/pdf.svg" class="img-pdf">
                  <bold>PDF Resume Download</bold>
              </a>
            </li>
            <li>
              <a href="https://linkedin.com/in/juscilan/" id="start">LinkedIn</a>
            </li>
            <li>
              <a href="http://twitter.com/juscilan" id="start">Twitter</a>
            </li>
            <li>
              <a href="http://Github.com/juscilan" id="start">Github</a>
            </li>
            <li>
              <a href="http://medium.com/@juscilan" id="start">Medium</a>
            </li>
            <li>
              <a href="#sobre" class="scrollSuave">About me </a>
            </li>
        </ul>
        <ul class="side-nav" id="mobile-demo">
            <li>
              <a @click="hide()" class="waves-effect waves-light scrollSuave " href="#topo" id="startm" > <i class="material-icons left material-icons-align left" >store</i>Home</a>
            </li>
            <li>
              <a @click="AbreModal()" class="waves-effect waves-light scrollSuave" href="#topo" ><i class="material-icons left material-icons-align" >assignment_ind</i><bold>PDF Resume Download</bold></a>
            </li>
            <li>
              <a @click="hide()" class="waves-effect waves-light scrollSuave " href="https://linkedin.com/in/juscilan/" id="startm" ><i class="material-icons left material-icons-align left">phonelink</i>LinkedIn</a>
            </li>
            <li>
              <a @click="hide()" class="waves-effect waves-light scrollSuave " href="http://twitter.com/juscilan" id="startm" > <i class="material-icons left material-icons-align left" >portrait</i>Twitter</a>
            </li>
            <li>
              <a @click="hide()" class="waves-effect waves-light scrollSuave " href="http://Github.com/juscilan" id="startm" > <i class="material-icons left material-icons-align left" >receipt</i>Github</a>
            </li>
            <li>
              <a @click="hide()" class="waves-effect waves-light scrollSuave " href="http://medium.com/@juscilan" id="startm" > <i class="material-icons left material-icons-align left" >child_care</i>Medium</a>
            </li>
            <li>
              <a @click="hide()" class="waves-effect waves-light scrollSuave" href="#sobre" ><i class="material-icons left material-icons-align" >face</i>About me</a>
            </li>
        </ul>
      </div>
    </nav>
  </div>            
</template>

<script>

import { scroll } from './common/jm-scroll'

export default {
  data () {
    return {
      modal: {
        titulo: 'Thank you for downloading my resume!',
        mensagem: 'Please, enter with your access KEY:',
        tipo: 'DOWNLOAD',
        inputvisible: true,
        senha: '',
        btnokvisible: true,
        dados: this.store
      }
    }
  },
  mounted () {
    scroll('scrollSuave')
  },
  methods: {
    baixar () {
      jQuery('#modal1').modal('close')
    },
    hide () {
      jQuery('.button-collapse').sideNav('hide')
    },
    AbreModal: function () {
      let data = JSON.parse(JSON.stringify(this.$data.modal))
      this.$store.commit('ATUALIZA_MODAL', data)
      jQuery('#modal1').modal('open')
      jQuery('.button-collapse').sideNav('hide')
      document.getElementById('senhaModal').focus()
    }
  },
  computed: {
    state: function () {
      return this.$store.state.Modal
    }
  }
}
</script>

<style>
  html {
    font-family: GillSans, Calibri, Trebuchet, sans-serif;
  }

  .pdf-resume {
    font-weight: 900;
  }

  .img-pdf {
    width: 20px;
    margin: -4px;
  }

  @media only screen and (max-width: 577px) {
    .hamburguer{
      position: fixed;
      z-index: 9999;
      font-size: 60%;
    }
  }

  @media only screen and (min-width:321px) and (max-width:768px){
    #nav {
      position: fixed;
      z-index: 9999;
    }
    .nav-regular {
      margin-right: 1%;
    }
    .brand-logo{
      left: 2%;
    }
  }

  @media only screen and (min-width: 769px) {
    #nav {
      position: fixed;
      z-index: 9999;
    }
    .nav-regular {
      margin-right: 1%;
    }
    .brand-logo{
      left: 2%;
    }
  }

  ul li a {
    float: left;
  }
</style>



// WEBPACK FOOTER //
// jm-a-nav.vue?4d9d26db